import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function SecurityBadges() {
  return <div className="flex justify-center items-center" data-id="element-108">
      <div className="flex items-center gap-2" data-id="element-109">
        <ShieldCheckIcon className="w-5 h-5 text-green-600" data-id="element-110" />
        <span className="text-sm text-gray-600 font-medium" data-id="element-111">SSL Secured</span>
      </div>
    </div>;
}